import React, { useState, useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
//components
import Btn from "../../../../../components/buttons/standard/btn";
import BaseModal from '../../../../../components/Modal'
import SimpleInputV2 from "../../../../../components/inputs/simple_input/input_v2";
//utils
import { isMobile, postReqOptBuilder } from "../../../../../utils/main_utils";
//constants
import { para_be } from '../../../../../config';
import DropdownWithCheckboxes from "../../../../../components/dropdowns/muiSelect/muiMultiSelect";


const AddNewTenancyModal = ({ open, handleClose, performFetch, setNotifState }) => {
    const endUserData = useSelector((state) => state.config.endUserData);

    const [availableUnits, setAvailableUnits] = useState({});
    const [inputError, setInputError] = useState([]);
    const [loading, setLoading] = useState(false);
    const isMobileDevice = isMobile();
    const [selectedUnits, setSelectedUnits] = useState([]);
    const [tenantName, setTenantName] = useState(null);
    const [checkIn, setCheckIn] = useState(null);
    const [checkOut, setCheckOut] = useState(null);
    const [rent, setRent] = useState(null);
    const [deposit, setDeposit] = useState(null);
    const [email, setEmail] = useState(null);
    const [mobile, setMobile] = useState(null);


    useEffect(() => {
        fetch(`${para_be}/units/list`, { method: 'GET', credentials: 'include' })
        .then(response => response.json())
        .then(response => {
            if (response.status === 200) {
                const units = response.result.reduce((acc, unit) => {
                    return {
                        ...acc,
                        [unit.pid]: {
                            primary: `(${unit.ext_ref}) ${unit.subject}`,
                            secondary: unit?.group
                        }
                    }
                }, {});
                setAvailableUnits(units);
            }
        })
        .catch(error => {
            console.error('Error fetching units:', error);
            setNotifState({ text: 'Failed fetching target units', type: 'error' });
        });
    }, []);
    
    
    const handleApprove = () => {
        setLoading(true);
        const body = {
            pid: selectedUnits.length > 0 ? selectedUnits : "",
            renters: tenantName,
            check_in: checkIn,
            check_out: checkOut,
            currency: 'usd',
            rate: rent,
            deposit: deposit,
            email: email,
            mobile: mobile,
        }
        const requiredFields  = ["pid", "renters", "check_in", "check_out", "rate", "email"];
        let isAuthorized = true;
        for (const field of requiredFields) {
            if (!body[field] || body[field].length === 0) {
                setInputError(prev => [...prev, field]);
                isAuthorized = false;
            }
        }
        if (!isAuthorized) {
            setLoading(false);
            return;
        }
        
        setNotifState(null);
        console.log("Adding new lease");
        fetch(`${para_be}/tenancies/create`, postReqOptBuilder({
                ip: endUserData?.ip,
                ...body,
            })
        )
        .then((response) => response.json())
        .then((response) => {
            if (response.status === 200) {
                performFetch();
                handleClose();
                setNotifState({type: 'success', text: "Lease created successfully"});
            } else {
                setNotifState({type: 'error', text: response.msg});
            }
            setLoading(false);
        })
        .catch((error) => {
            console.log(error);
            setNotifState({type: 'error', text: "An error has occurred, please try again later"});
            setLoading(false);
        });
    };
    
    return (
        <BaseModal
            open={open}
            onClose={handleClose}
            maxWidth={800}
        >
            <div className="p-6 max-w-md mx-auto bg-white">
                <div className="flex flex-col space-y-6">
                    <h2 className="text-2xl font-bold text-blue-600">Add New Lease</h2>
                    {/* Unit Input */}
                    <div className="flex flex-col gap-2 relative">
                        <label className="text-md font-medium text-gray-700">
                            Select Unit *
                        </label>
                        <DropdownWithCheckboxes 
                            options={availableUnits}
                            onChange={(t)=>{ setSelectedUnits(t); }}
                            label="Select Unit"
                            scrollable={true}
                            searchable={true}
                            multipleSelection={false}
                        />
                    </div>
                    {/* Tenant Name Input */}
                    <SimpleInputV2
                        id="tenant_name"
                        name="tenant_name"
                        label="Primary Tenant Name *"
                        placeholder="Enter Primary Tenant Name"
                        type="text"
                        inputError={inputError.includes("renters") ? "Please enter Primary Tenant Name" : undefined}
                        on_change={(e) => setTenantName(e.target.value)}
                    />
                    {/* Move In/Out Inputs */}
                    <div className="flex justify-between space-x-4">
                        <SimpleInputV2
                            id="check_in"
                            name="check_in"
                            label="Move In Date *"
                            placeholder="Enter Move In Date"
                            type="date"
                            inputError={inputError.includes("check_in") ? "Please enter Move In Date" : undefined}
                            on_change={(e) => setCheckIn(e.target.value)}
                        />
                        <SimpleInputV2
                            id="checkout"
                            name="checkout"
                            label="Move Out Date *"
                            placeholder="Enter Move Out Date"
                            type="date"
                            inputError={inputError === "check_out" ? "Please enter Move Out Date" : undefined}
                            on_change={(e) => setCheckOut(e.target.value)}
                        />
                    </div>
                    {/* Email Input */}
                    <SimpleInputV2
                        id="email"
                        name="email"
                        label="Tenant Email *"
                        placeholder="Enter Tenant Email"
                        type="text"
                        inputError={inputError.includes("email") ? "Please enter Tenant Email" : undefined}
                        on_change={(e) => setEmail(e.target.value)}
                    />
                    {/* Mobile Input */}
                    <SimpleInputV2
                        id="phone"
                        name="phone"
                        label="Tenant Mobile Number"
                        placeholder="Enter Tenant Email"
                        type="text"
                        inputError={inputError.includes("mobile") ? "Please enter Tenant Mobile Number" : undefined}
                        on_change={(e) => setMobile(e.target.value)}
                    />
                    {/* Rent Input */}
                    <SimpleInputV2
                        id="rent"
                        name="rent"
                        label="Rent Amount *"
                        placeholder="Enter Rent Amount"
                        type="text"
                        inputError={inputError.includes("rate") ? "Please enter Rent Amount" : undefined}
                        on_change={(e) => setRent(e.target.value)}
                    />
                    {/* Deposit Input */}
                    <SimpleInputV2
                        id="deposit"
                        name="deposit"
                        label="Deposit Amount"
                        placeholder="Enter Deposit Amount"
                        type="text"
                        inputError={inputError.includes("deposit") ? "Please enter Deposit Amount" : undefined}
                        on_change={(e) => setDeposit(e.target.value)}
                    />

                    <Btn text={loading ? "Loading..." : "Create"} type="primary" onclick={handleApprove} />
                </div>
            </div>
        </BaseModal>
    )
}

export default AddNewTenancyModal;